import { Injectable } from '@angular/core';
import { VersesModel, VersesTextField } from '@core/models/bible/verses-model';
import { ApiService } from '@core/service/api/api.service';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { ApiUrl } from '@shared/tools/constants/api.endpoints';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VersesService extends UnsubscribeOnDestroyAdapter
{
  endpoint: string = ApiUrl.VersesV1;
  public textField=VersesTextField;
  public loadingDataList=false;
  public versesDataList: VersesModel[]  = [];

  constructor( private apiService: ApiService) {super();}

  getVersesByChapter(book:string, chapter:string, dbname:string='lsg', ) : Observable<any>{
    return this.apiService.getData(`${this.endpoint}/by-chapter/${dbname}/${book}/${chapter}` );
  }
  getVersesByVerse(dbname:string='lsg', book:string, verse:string) : Observable<any>{
    return this.apiService.getData(`${this.endpoint}/by-verse/${dbname}/${book}/${verse}` );
  }
  getCountVerse(book:string, chapter:string) : Observable<any>{
    return this.apiService.getData(`${this.endpoint}/count-verse/${book}/${chapter}` );
  }

  getOne( id: string ) : Observable<any> {
    return this.apiService.getData(`${this.endpoint}/${id}` );
  }


  async loadVersesByChapter(book:any, chapter:any)  {
    this.loadingDataList=true;
    this.subs.sink = await this.getVersesByChapter(book, chapter).subscribe({
      next: (result) => {
        this.versesDataList = result;
        //console.log(`this.versesDataList:`, this.versesDataList);
      },
      error: (ex) => {
        console.log(ex);
        this.loadingDataList=false;
      },
      complete: () => {
        this.loadingDataList=false;
      }
    });
  }

}
